import { useUpdateBrandDetailsAction } from '@/hooks/actions/use-update-brand-details-action';
import { Button, Stack } from '@chakra-ui/react';
import { CountrySelect, NoticePanel } from '@fluenceur/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function BillingCountryStep({
  initialCountry,
  refresh,
  paid = false,
}: {
  initialCountry: string;
  refresh: () => Promise<unknown>;
  paid?: boolean;
}) {
  const { t, i18n } = useTranslation();
  const [country, setCountry] = useState(initialCountry);
  const [error, setError] = useState(false);
  const update = useUpdateBrandDetailsAction();
  const save = async () => {
    if (!country || update.isPending) return;
    setError(false);
    try {
      await update.mutateAsync({ country });
      await refresh();
    } catch {
      setError(true);
    }
  };
  return (
    <Stack gap={4}>
      <NoticePanel
        tone="info"
        title={t(paid ? 'planChoice.paid.countryBody' : 'onboarding.billing.countryBody')}
      />
      <CountrySelect
        portalled={false}
        placeholder={t('settings.brandInformationForm.selectCountry')}
        emptyText={t('onboarding.billing.noCountries')}
        value={country}
        onValueChange={setCountry}
        locale={i18n.language}
        variant="outline"
        required
      />
      {error && (
        <NoticePanel tone="warning" title={t('settings.brandInformationForm.updateError')} />
      )}
      <Button onClick={() => void save()} loading={update.isPending} disabled={!country}>
        {t('onboarding.billing.saveCountry')}
      </Button>
    </Stack>
  );
}
